/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IProductionSlice {
	productionsAddType: string;
	productionsPage: number;
	productionsTotal: number;
	productionsPageSize: number;
	productionsSelectedRecords: any[];
	productionsOpenConfirmationModalDelete: any;
	productionsOpenConfirmationModalVerify: any;
	productionsOpenConfirmationModalMint: any;
	productionsQueryParams: any;
	productionsSortStatus: any;
	productionsSortParams: any;
	productionsSelectedRow: any;
	productionsImportErrors: any;
	productionsDefaultSelectedFields: any;
	productionsTotalPages: number;
	setProductionsDefaultSelectedFields: (
		productionsDefaultSelectedFields: any
	) => void;
	setProductionsAddType: (
		_productionsAddType: string
	) => void;

	setProductionsImportErrors: (_errors: any) => void;
	setProductionsPage: (_productionsPage: number) => void;
	setProductionsSelectedRecords: (
		_productionsPage: any
	) => void;
	setProductionsOpenConfirmationModalDelete: (
		_productionsOpenConfirmationModalDelete: any
	) => void;
	setProductionsOpenConfirmationModalVerify: (
		_productionsOpenConfirmationModalVerify: any
	) => void;
	setProductionsOpenConfirmationModalMint: (
		_productionsOpenConfirmationModalMint: any
	) => void;
	setProductionsQueryParams: (
		_productionsQueryParams: any
	) => void;
	setProductionsSortStatus: (
		_productionsSortStatus: any
	) => void;
	setProductionsSortParams: (
		_productionsSortParams: any
	) => void;
	setProductionsSelectedRow: (_production: any) => void;
	setProductionsPageSize: (_pageSize: any) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */
const initialState = {
	productions: [],
	productionsTotal: 0,
	productionsPage: 1,
	productionsPageSize: 100,
	productionsTotalPages: 0,
	productionsSelectedRecords: [],
	productionsQueryParams: {},
	productionsSelectedRow: {},
	productionsSortParams: '-createdAt',
	productionsSortStatus: {},
	productionsImportErrors: null,
	productionsOpenConfirmationModalDelete: {
		open: false,
		params: '',
	},
	productionsOpenConfirmationModalVerify: {
		open: false,
		params: '',
	},
	productionsOpenConfirmationModalMint: {
		open: false,
		params: '',
	},
	productionsAddType: 'fromFile',
	productionsDefaultSelectedFields: [],
};

export const createProductionsSlice: StateCreator<
	TStore,
	[],
	[],
	IProductionSlice
> = (set) => ({
	...initialState,
	setProductionsDefaultSelectedFields: (
		_productionsDefaultSelectedFields: any
	) =>
		set({
			productionsDefaultSelectedFields:
				_productionsDefaultSelectedFields,
		}),
	setProductionsAddType: (_productionsAddType: string) =>
		set({
			productionsAddType: _productionsAddType,
		}),
	setProductionsImportErrors: (_errors: any) =>
		set({ productionsImportErrors: _errors }),
	setProductionsSelectedRow: (_production: any) =>
		set({ productionsSelectedRow: _production }),
	setProductionsSortParams: (_sortStatus: any) =>
		set({ productionsSortParams: _sortStatus }),
	setProductionsSortStatus: (_sortStatus: any) =>
		set({ productionsSortStatus: _sortStatus }),
	setProductionsQueryParams: (_queryParams: number) =>
		set({ productionsQueryParams: _queryParams }),
	setProductionsTotal: (_total: number) =>
		set({ productionsTotal: _total }),
	setProductionsOpenConfirmationModalDelete:
		(_productionsOpenConfirmationModalDelete: {
			open: boolean;
			params: any;
		}) =>
			set({
				productionsOpenConfirmationModalDelete:
					_productionsOpenConfirmationModalDelete,
			}),
	setProductionsOpenConfirmationModalMint:
		(_productionsOpenConfirmationModalMint: {
			open: boolean;
			params: any;
		}) =>
			set({
				productionsOpenConfirmationModalMint:
					_productionsOpenConfirmationModalMint,
			}),
	setProductionsOpenConfirmationModalVerify:
		(_productionsOpenConfirmationModalVerify: {
			open: boolean;
			params: any;
		}) =>
			set({
				productionsOpenConfirmationModalVerify:
					_productionsOpenConfirmationModalVerify,
			}),
	setProductionsPage: (_page: number) =>
		set({ productionsPage: _page }),
	setProductionsPageSize: (_pageSize: number) =>
		set({ productionsPageSize: _pageSize }),
	setProductionsTotalPages: (_totalPages: number) =>
		set({ productionsTotalPages: _totalPages }),
	setProductionsSelectedRecords: (
		_productionsSelectedRecords: any
	) =>
		set({
			productionsSelectedRecords:
				_productionsSelectedRecords,
		}),
});
